import React from 'react';
import {Card, Col, Row} from 'antd';

import EnrolledStatisticsChart from '../Charts/EnrolledStatisticsChart';
import TotalTimeSpentChart from '../Charts/TotalTimeSpentChart';
import OrganizationalUnitChart from '../Charts/OrganizationalUnitChart';
import CompletionOverTimeChart from '../Charts/CompletionOverTimeChart';
import TopStudentTable from '../Charts/TopStudentTable';

import StatisticsDownload from '../../FormCampaign/CampaignOverview/StatisticsDownload';

interface OverviewProps {
    programId: number;
}

const Overview: React.FC<OverviewProps> = ({programId}) => (
    <div>
        <StatisticsDownload campaignId={programId} />
        <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
                <Card size='small'>
                    <EnrolledStatisticsChart programId={programId}/>
                </Card>
            </Col>
            <Col xs={24} md={12}>
                <Card size='small'>
                    <TotalTimeSpentChart programId={programId}/>
                </Card>
            </Col>
            <Col xs={24} md={12}>
                <Card size='small'>
                    <OrganizationalUnitChart programId={programId}/>
                </Card>
            </Col>
            <Col xs={24} md={12}>
                <Card size='small'>
                    <CompletionOverTimeChart programId={programId}/>
                </Card>
            </Col>
            <Col xs={24} md={12}>
                <Card size='small'>
                    <TopStudentTable programId={programId}/>
                </Card>
            </Col>
        </Row>
    </div>
);

export default Overview;
